import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import SEO from '../components/SEO';
import { breadcrumbSchema, webPageSchema } from '../lib/seo';

// /contact is a canonical URL for search but the actual booking UX lives at /book.
// We render a lightweight indexable page and immediately redirect the user to /book.
export default function ContactPage() {
  const path = '/contact';
  const title = 'Book a Free Discovery Call | Founder Growth Collective';
  const description = 'Book a free 30-minute discovery call with Hannah Hulley to explore where founder-led sales is holding your startup back and what a structured sales function could look like.';
  const bc = [{ name: 'Home', path: '/' }, { name: 'Contact', path }];
  const schemas = [
    webPageSchema({ path, name: title, description }),
    breadcrumbSchema(bc),
  ];

  return (
    <>
      <SEO title={title} description={description} path={path} schemas={schemas} />
      {/* Crawlable content — also acts as a fallback if JS redirect fails */}
      <div style={{ position: 'absolute', left: '-9999px', top: 0 }} aria-hidden="true">
        <h1>Book a Free Discovery Call with Founder Growth Collective</h1>
        <p>{description}</p>
        <p>Free 30-minute discovery call. Google Meet link included. 24-hour notice required. 9:00 AM – 6:00 PM UK Time.</p>
        <p><Link to="/book">Continue to booking</Link></p>
      </div>
      <Navigate to="/book" replace />
    </>
  );
}
